import type { TFunction } from "i18next";

import type { CmsPromoSlide, LoginButtonConfig } from "../../types/homeLanding";

import { DEFAULT_LOGIN_URL } from "./loginUrls";

export function buildDefaultLoginButtons(t: TFunction): LoginButtonConfig[] {
  return [
    {
      kind: "business_new",
      title: t("btn_business"),
      description: t("btn_business_desc"),
      url: DEFAULT_LOGIN_URL.business_new,
      featured: true,
      iconKey: "briefcase",
      order: 0,
    },

    {
      kind: "personal",
      title: t("btn_personal"),
      description: t("btn_personal_desc"),
      url: DEFAULT_LOGIN_URL.personal,
      featured: false,
      iconKey: "user",
      order: 2,
    },
  ];
}

export function buildDefaultPromoSlides(
  t: TFunction,
  urlLang: string,
): CmsPromoSlide[] {
  return [
    {
      id: "mia-pos",
      title: t("promo4_title"),
      description: t("promo4_desc"),
      url: `https://fincombank.com/${urlLang}/mypos`,
      tagText: t("tag_new"),
      tagVariant: "teal",
      iconKey: "smartphone",
      gradientKey: "miaPos",
    },
    {
      id: "mastercard-business",
      title: t("promo5_title"),
      description: t("promo5_desc"),
      url: `https://fincombank.com/${urlLang}/mastercard-business`,
      tagText: t("tag_business"),
      tagVariant: "slate",
      iconKey: "creditcard",
      gradientKey: "mcBiz",
    },
    {
      id: "program-373",
      title: t("promo6_title"),
      description: t("promo6_desc"),
      url: `https://fincombank.com/${urlLang}/programul-373`,
      tagText: t("tag_offer"),
      tagVariant: "orange",
      iconKey: "briefcase",
      gradientKey: "program373",
    },
    {
      id: "depozit-aur",
      title: t("promo1_title"),
      description: t("promo1_desc"),
      url: `https://fincombank.com/${urlLang}/depozit-varsta-de-aur`,
      tagText: t("tag_offer"),
      tagVariant: "orange",
      iconKey: "coins",
      gradientKey: "depozit",
    },
    {
      id: "promo-valencia",
      title: t("promo2_title"),
      description: t("promo2_desc"),
      url: `https://fincombank.com/${urlLang}/oferte-speciale-mastercard/`,
      tagText: t("tag_prizes"),
      tagVariant: "pink",
      iconKey: "ticket",
      gradientKey: "valencia",
    },
    {
      id: "credit-express",
      title: t("promo3_title"),
      description: t("promo3_desc"),
      url: `https://fincombank.com/${urlLang}/express-credit-online/`,
      tagText: t("tag_express"),
      tagVariant: "teal",
      iconKey: "zap",
      gradientKey: "express",
    },
  ];
}
